module.exports = __webpack_public_path__ + "static/img/android1.c5d1670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/android1.png
// module id = 5PXt
// module chunks = 1